import { Button } from '@/design/components'
import { Logo } from './Logo'

export interface SplashProps {
  label?: string
  detail?: string
  onRetry?: () => void
}

/** Pełnoekranowy stan ładowania/błędu przed wejściem do powłoki aplikacji. */
export function Splash({ label = 'Wczytywanie…', detail, onRetry }: SplashProps) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-bg px-6 text-center">
      <Logo tone="light" />
      <div>
        <p className="text-base text-ink">{label}</p>
        {detail ? <p className="mt-1 text-small text-muted">{detail}</p> : null}
      </div>
      {onRetry ? (
        <Button variant="secondary" size="sm" onClick={onRetry}>
          Spróbuj ponownie
        </Button>
      ) : null}
    </div>
  )
}
